import React from 'react';
import './Cart.css';
import { Link, useNavigate } from 'react-router-dom';
import { useContext } from "react";
import SaleContext from "./context/SaleContext";
import { getSalePrice } from "./utils/pricing";

const Cart = ({ cart = [], setCartItems }) => {
  const { sale } = useContext(SaleContext);
  const navigate = useNavigate();

  const handleQuantityChange = (productId, size, delta) => {
    setCartItems(prev =>
      prev.map(item =>
        item._id === productId && item.selectedSize === size
          ? { ...item, quantity: Math.max(1, (item.quantity || 1) + delta) }
          : item
      )
    );
  };

  const handleRemove = (productId, size) => {
    setCartItems(prev =>
      prev.filter(item => !(item._id === productId && item.selectedSize === size))
    );
  };

  const handleCheckout = () => {
    navigate('/checkout', { state: { cart } });
  };

  const subtotal = cart.reduce(
    (acc, item) =>
      acc + (item.price || 0) * (item.quantity || 1),
    0
  );

  const totalSavings = cart.reduce((acc, item) => {

    const finalPrice = getSalePrice(item.price, sale);

    return (
      acc +
      (item.price - finalPrice) *
      (item.quantity || 1)
    );

  }, 0);

  const total = subtotal - totalSavings;

  return (
    <div className="cart">
      <h2>Your Cart</h2>
      {cart.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <>
          <div className="cart-list">
            <ul>
              {cart.map(item => {
                const salePrice = getSalePrice(item.price, sale);

                const isSaleActive =
                  Boolean(sale) &&
                  salePrice < item.price;
                const key = `${item._id}-${item.selectedSize}`;
                return (
                  <li key={key} className="cart-item">
                    <img src={item.images?.main} alt={item.name} className="cart-img" />
                    <div className="cart-details">
                      <Link to={`/product/${item._id}`} className="view-button">
                        <h3 className="cart-item-name">{item.brand}</h3>
                        <h3 className="cart-item-name"> in {item.name}</h3>
                      </Link>
                      <div className="cart-item-info">
                        <span className="cart-item-size">Size: {item.selectedSize}</span>
                        <div className="shop-product-price-container">
                          {isSaleActive ? (
                            <>
                              <p className="shop-product-original-price">
                                ₹{item.price}
                              </p>

                              <p className="shop-product-sale-price">
                                ₹{salePrice}
                              </p>
                            </>
                          ) : (
                            <p className="shop-product-price">
                              ₹{item.price}
                            </p>
                          )}
                          </div>
                      </div>
                      <div className="quantity-controls">
                        <div className="qty-box">
                          <button onClick={() => handleQuantityChange(item._id, item.selectedSize, -1)}>-</button>
                          <span>{item.quantity || 1}</span>
                          <button onClick={() => handleQuantityChange(item._id, item.selectedSize, 1)}>+</button>
                        </div>
                        <button onClick={() => handleRemove(item._id, item.selectedSize)}>Remove</button>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="total">
            <div className="cart-summary-row">
              <span>Subtotal</span>
              <span>₹{subtotal.toFixed(2)}</span>
            </div>

            {totalSavings > 0 && (
              <div className="cart-summary-row savings">
                <span>You Saved</span>
                <span>-₹{totalSavings.toFixed(2)}</span>
              </div>
            )}

            <div className="cart-summary-row final">
              <span>Total</span>
              <span>₹{total.toFixed(2)}</span>
            </div>

            <p className="cart-scarcity-note">
              Limited run: <br/> The items in your cart once sold out, may not restocked. Your STILL pair might be one of very few. 
            </p>

            <button
              className="checkout-button"
              onClick={handleCheckout}
            >
              Checkout
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;
